import React, { useState, useEffect } from 'react'
import "./media-upload-thumbnail.scss"
const DynamicImage = ({ imgURL, tagName = 'img', ...props }) => {
  const [src, setSrc] = useState(null)
  useEffect(() => {
    let img = new Image()
    img.src = imgURL
    img.onload = () => {
      setSrc(imgURL)
    }
  }, [imgURL])
  const Tag = tagName
  return (
    <>
      {tagName === 'source' && (
        <>
          {
            <Tag
              className={`${src !== null ? 'loaded' : 'loading'}`}
              srcSet={src}
              {...props}
            ></Tag>
          }
        </>
      )}

      {tagName === 'img' && <>{<Tag className={`${src !== null ? 'loaded' : 'loading'}`} src={imgURL} {...props} />}</>}
      {tagName === 'video' && (
        <>
          {
            <Tag {...props}>
              <source src={imgURL} type="video/mp4" />
            </Tag>
          }
        </>
      )}
    </>
  )
}

const makeArrayOfThumbnails = thumbnail => {
  let extArr = thumbnail.split('.')
  let name = extArr[0]
  let sizedThumbnails = [
    { size: 'small', width: 300 },
    { size: 'medium', width: 600 },
    { size: 'large', width: 900 },
  ]
  let sizedThumbnailsArray = sizedThumbnails.map(thumb => {
    return {
      size: thumb.size,
      width: thumb.width,
      uri: `https://mediaupload-thumbnails.s3.amazonaws.com/${thumb.size}--${name}.jpg`,
    }
  })
  return sizedThumbnailsArray
}

const MediaUploadThumbnail = ({ thumbnail, mediaType }) => {
  let originalImage = `${process.env.SITE_ASSET_URL}/${thumbnail}`

  let sizedThumbnailsArray = makeArrayOfThumbnails(thumbnail)

  return (
    <div className="media-upload-thumbnail">
      <picture>
        {sizedThumbnailsArray.map((thumbnail, index) => {
          return (
            <DynamicImage
              key={index}
              imgURL={thumbnail.uri}
              tagName="source"
              media={`(max-width: ${thumbnail.width}px)`}
            />
          )
        })}
        <DynamicImage
          tagName={`${mediaType === 'video' ? 'video' : 'img'}`}
          imgURL={originalImage}
        />
      </picture>
    </div>
  )
}

export default MediaUploadThumbnail
